/**
 * 仓库接口
 */
import axios from 'axios'
import env from '../env'

export default class RepositoryAPI {
  /** 仓库列表 */
  static list () {
    const url = `${env.JMOBILE}/mall/resp/listV2`
    return axios.get(url).then((res: any) => {
      if (res.success) {
        throw res
      }
      return res
    })
  }
}
